import { render, staticRenderFns } from "./ParcelSyncHistoryPopup.vue?vue&type=template&id=6890b07a&scoped=true"
import script from "./ParcelSyncHistoryPopup.vue?vue&type=script&lang=js"
export * from "./ParcelSyncHistoryPopup.vue?vue&type=script&lang=js"
import style0 from "./ParcelSyncHistoryPopup.vue?vue&type=style&index=0&id=6890b07a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6890b07a",
  null
  
)

export default component.exports